<template>
  <div class='mainContainer'>
    <div class='nav'>
      <el-form :model='searchForm' label-width='100px' :inline='true'>
        <el-form-item label='对账单编号：'>
          <el-input v-model='searchForm.settNo' size='mini' placeholder='请输入对账单编号' />
        </el-form-item>
        <el-form-item label='对账单标题：'>
          <el-input v-model='searchForm.title' size='mini' placeholder='请输入对账单标题' />
        </el-form-item>
        <el-form-item label='公司名称：'>
          <el-input v-model='searchForm.companyNameNew' size='mini' placeholder='请输入公司名称' />
        </el-form-item>
        <el-form-item label='类型：'>
          <el-select v-model='searchForm.type' filterable size='mini' style='width:150px'
                     placeholder='请选择类型'>
            <el-option v-for='item in typeOption' :key='item.label' :label='item.label'
                       :value='item.value' />
          </el-select>
        </el-form-item>
        <el-form-item label='结算方式：'>
          <el-select v-model='searchForm.settType' filterable size='mini' style='width:150px'
                     placeholder='请选择结算方式'>
            <el-option v-for='item in settTypeOption' :key='item.label' :label='item.label'
                       :value='item.value' />
          </el-select>
        </el-form-item>
        <el-form-item label='状态：'>
          <el-select v-model='searchForm.status' filterable size='mini' style='width:150px'
                     placeholder='请选择状态'>
            <el-option v-for='item in statusOption' :key='item.label' :label='item.label'
                       :value='item.value' />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'> 查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class='content'>
      <el-table
        ref='registerTable'
        row-key='id'
        v-loading='tableLoading'
        :data='tableData'
        style='width: 100%'
        border
        :header-cell-style='headerCellStyle'>
        <el-table-column label='序号' type='index' align='center' min-width='50' />
        <el-table-column label='对账单编号' prop='settNo' align='center' />
        <el-table-column label='标题' prop='title' align='center' />
        <el-table-column label='公司名称' prop='companyNameNew' align='center' />
        <el-table-column label='对账单类型' prop='type' align='center' :formatter='typeFormat' />
        <el-table-column label='结算方式' prop='settType' align='center' :formatter='settTypeFormat' />
        <el-table-column label='税率' prop='taxRate' align='center' />
        <el-table-column label='含税费用' prop='taxPrice' align='center' />
        <el-table-column label='不含税费用' prop='noTaxPrice' align='center' />
        <el-table-column label='状态' prop='status' align='center' :formatter='statusFormat' />
        <el-table-column label='操作' width='240' align='center'>
          <template slot-scope='scope'>
            <el-button size='mini' class='searchBtn' type='primary'
                       @click='btnClick("info",scope.row)'>详情
            </el-button>
            <el-button size='mini' v-if='scope.row.status === 6' type='primary'
                       @click='btnClick("audit",scope.row)'>审核
            </el-button>
            <el-button size='mini' v-if='scope.row.status === 7' type='primary'
                       @click='btnClick("reject",scope.row)'>驳回
            </el-button>
            <el-button size='mini' v-if='scope.row.status === 7' type='primary'
                       @click='btnClick("submitBilling",scope.row)' class='yellow-bg'>
              提交开票
            </el-button>
            <el-button size='mini' v-if='scope.row.status === 8' type='primary'
                       @click='btnClick("printInvoice",scope.row)' class='yellow-bg'>
              打印发票
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div>
    </div>

    <!-- 审核 -->
    <vehicle-settlement-form ref='vehicleSettlementFormRef' @searchBtn='searchBtn' />
    <!-- 详情 -->
    <vehicle-settlement-info ref='vehicleSettlementInfoRef' />
    <!-- 提交开票 -->
    <submit-billing ref='submitBillingRef' @searchBtn='searchBtn' />
  </div>
</template>

<script>
  import VehicleSettlementForm
    from '@/views/audit/financialAudit/vehicleSettlement/components/form';
  import VehicleSettlementInfo
    from '@/views/audit/financialAudit/vehicleSettlement/components/info';
  import {
    vehicleSettlementList,
    vehicleSettlementPrint,
    vehicleSettlementRejectOrSubmit,
  } from '@/service/financial';
  import SubmitBilling from './components/submitBilling';

  export default {
    name: 'vehicleSettlement',
    components: {
      SubmitBilling,
      VehicleSettlementInfo,
      VehicleSettlementForm,
    },
    data() {
      return {
        searchForm: {
          page: 1,
          rows: 10,
        },
        typeOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 1,
            label: '委托商运费',
          },
          {
            value: 2,
            label: '委托商港口费',
          },
          {
            value: 3,
            label: '暂无',
          },
          {
            value: 4,
            label: '公路供应商托运费',
          },
          {
            value: 5,
            label: '水路供应商运费',
          },
          {
            value: 6,
            label: '港口供应商操作费',
          },
          {
            value: 7,
            label: '港口供应商燃油费',
          },
          {
            value: 8,
            label: '港口堆存费',
          },
          {
            value: 9,
            label: '提车费',
          },
          {
            value: 13,
            label: '港口库房委托商结算',
          },
          {
            value: 14,
            label: '港口库房供应商结算',
          },
        ],
        settTypeOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 1,
            label: '合同价',
          },
          {
            value: 2,
            label: '预结算价',
          },
        ],
        statusOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 6,
            label: '待财务审核',
          },
          {
            value: 7,
            label: '待提交开票',
          },
          {
            value: 8,
            label: '待打印发票',
          },
          {
            value: 9,
            label: '待财务核销',
          },
        ],
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        total: 0,
      };
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      this.searchBtn();
    },
    methods: {
      btnClick(str, row) {
        switch (str) {
          case 'info':
            this.$refs.vehicleSettlementInfoRef.dialogOpen(row);
            break;
          case 'audit':
            this.$refs.vehicleSettlementFormRef.dialogOpen('审核', row);
            break;
          case 'reject':
            this.reject(row.id);
            break;
          case 'submitBilling':
            // this.submitBilling(row.id);
            this.$refs.submitBillingRef.dialogOpen(row);
            break;
          case 'printInvoice':
            this.printInvoice(row.id);
            break;
        }
      },
      reject(id) {
        this.$confirm('确认要驳回当前数据么？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const {
              status,
              message,
            } = await vehicleSettlementRejectOrSubmit({
              type: 2,
              id,
            });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            await this.getTableData();
          });
      },
      printInvoice(id) {
        this.$confirm('确认要打印当前数据么？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const {
              status,
              message,
            } = await vehicleSettlementPrint({ id });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            await this.getTableData();
          });
      },
      // 状态格式化
      typeFormat(row, column, cellValue) {
        switch (cellValue) {
          case 1:
            return '委托商运费';
          case 2:
            return '委托商港口费';
          case 3:
            return '暂无';
          case 4:
            return '公路供应商托运费';
          case 5:
            return '水路供应商运费';
          case 6:
            return '港口供应商操作费';
          case 7:
            return '港口供应商燃油费';
          case 8:
            return '港口堆存费';
          case 9:
            return '提车费';
            case 10:
              return '委托商运费(资源车)';
          case 13:
            return '港口库房委托商结算';
          case 14:
            return '港口库房供应商结算';
        }
      },
      // 状态格式化
      statusFormat(row, column, cellValue) {
        switch (cellValue) {
          case 6:
            return '待财务审核';
          case 7:
            return '待提交开票';
          case 8:
            return '待打印发票';
          case 9:
            return '待财务核销';
        }
      },
      // 结算方式格式化
      settTypeFormat(row, column, cellValue) {
        switch (cellValue) {
          case 1:
            return '合同价';
          case 2:
            return '预结算价';
        }
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await vehicleSettlementList(this.searchForm);
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data.records;
        this.total = data.total;
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
    },
  };
</script>


<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 15px;
    background-color: #fff;

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
    }

    .content {
      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-top: 10px;

        span {
          font-size: 13px;
        }
      }
    }
  }
</style>
